export default __webpack_public_path__ + "static/media/floral.d295861d.svg";